import { useEffect, useState } from 'react';
import { api } from '../api';
import { useSetting } from '../units/setting';
import { Product } from '../data/Product';

type UseProductListData = {
    line_uid: string,
    login: string,
};

export function useProductList(data: UseProductListData) {
    const [productList, setProductList] = useState<Product[]>([]);
    const [isLoading, setLoading] = useState(false);

    useEffect(() => {
        if (data) {
            setLoading(true);
            api.productProgress({
                ...data,
                barcode: '',
                product_model_id: '',
                sn_code: '',
                location: '',
            }).then((resData) => {
                setLoading(false);
                setProductList(resData);
            }).catch(() => {
                setLoading(false);
            });
        }
    }, [JSON.stringify(data)]);

    return {
        productList,
        isLoading,
    };
}
